import axios from 'axios'

const BASE_URL = 'https://mc-analytics.manyconvert.com'

/**
 * Verificar status das recomendações para uma loja
 * @param {string} storeUuid - UUID da loja
 * @returns {Promise<Object>} Status das recomendações
 */
export async function verificarStatusRecomendacoes(storeUuid) {
  try {
    const response = await axios.get(`${BASE_URL}/api/stores/${storeUuid}/recommendations/status`)
    return response.data
  } catch (error) {
    console.error('Erro ao verificar status das recomendações:', error)
    throw error
  }
}

/**
 * Ativar recomendações para uma loja
 * @param {string} storeUuid - UUID da loja
 * @param {Object} configuracao - Configurações das recomendações
 * @returns {Promise<Object>} Resposta da API
 */
export async function ativarRecomendacoes(storeUuid, configuracao) {
  try {
    const response = await axios.post(`${BASE_URL}/api/stores/${storeUuid}/recommendations/activate`, configuracao)
    return response.data
  } catch (error) {
    console.error('Erro ao ativar recomendações:', error)
    throw error
  }
}

/**
 * Desativar recomendações para uma loja
 * @param {string} storeUuid - UUID da loja
 * @returns {Promise<Object>} Resposta da API
 */
export async function desativarRecomendacoes(storeUuid) {
  try {
    const response = await axios.post(`${BASE_URL}/api/stores/${storeUuid}/recommendations/deactivate`)
    return response.data
  } catch (error) {
    console.error('Erro ao desativar recomendações:', error)
    throw error
  }
}

/**
 * Buscar métricas das recomendações (v2)
 * GET /api/v2/recommendations/metrics/store?store_uuid=...&start_date=...&end_date=...
 * @param {string} storeUuid - UUID da loja
 * @param {Object} params - start_date, end_date (YYYY-MM-DD), opcionais
 * @returns {Promise<Object>} Ex.: { data: { metricas_geral, metricas_periodo?, template_analytics? } }
 *   - Sem filtro de datas: costuma vir só `metricas_geral` (acumulado desde ativação).
 *   - Com start_date/end_date: `metricas_periodo` + opcional `template_analytics` (envios Meta).
 */
export async function buscarMetricasRecomendacoes(storeUuid, params = {}) {
  try {
    const qs = new URLSearchParams()
    qs.set('store_uuid', storeUuid)
    if (params.start_date) qs.set('start_date', params.start_date)
    if (params.end_date) qs.set('end_date', params.end_date)
    const query = qs.toString()
    const url = `${BASE_URL}/api/v2/recommendations/metrics/store?${query}`
    const response = await axios.get(url)
    return response.data
  } catch (error) {
    console.error('Erro ao buscar métricas das recomendações:', error)
    throw error
  }
}

/**
 * Listar recomendações geradas (para página de métricas)
 * @param {string} storeUuid - UUID da loja
 * @param {Object} params - start_date, end_date (YYYY-MM-DD), limit, offset
 * @returns {Promise<Object>} { data: { recommendations, pagination, filters } }
 */
export async function listarRecomendacoes(storeUuid, params = {}) {
  try {
    const qs = new URLSearchParams()
    if (params.start_date) qs.set('start_date', params.start_date)
    if (params.end_date) qs.set('end_date', params.end_date)
    if (params.limit != null) qs.set('limit', params.limit)
    if (params.offset != null) qs.set('offset', params.offset)
    const query = qs.toString()
    const url = `${BASE_URL}/api/stores/${storeUuid}/recommendations/list${query ? `?${query}` : ''}`
    const response = await axios.get(url)
    return response.data
  } catch (error) {
    console.error('Erro ao listar recomendações:', error)
    throw error
  }
}
